import Image from '@alltrails/core/components/Image';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import { useExperiments } from '@alltrails/experiments';
import { APP_STORE_URL_MAP } from '@alltrails/layout/components/Footer/StoreBadges/AppStore';
import { GOOGLE_PLAY_URL_MAP } from '@alltrails/layout/components/Footer/StoreBadges/GooglePlay';
import appleSrc from './images/badges/app-apple-en-US.svg';
import googleSrc from './images/badges/app-google-en-US.svg';
import QRCodeCondensedSvg from './qr-code-condensed.svg';
import QRCodeStackedSvg from './qr-code-stacked.svg';
import styles from './QRCodeDownload.module.scss';

const QRCodeDownload = () => {
  const experiments = useExperiments();
  const appInstallExperimentVariant = experiments?.['web-growth-rm-homepage-app-install-module']?.value;
  const QRCodeSvg = appInstallExperimentVariant === 'stacked' ? QRCodeStackedSvg : QRCodeCondensedSvg;
  const languageRegionCode = useLanguageRegionCode();
  return (
    <div className={styles.downloadCodeContainer}>
      <Image
        src={QRCodeSvg}
        alt="This QR code is intended to scan from a smartphone. If you have the AllTrails app, the link will open the app for you. If you don’t have the app, the link will take you to your device’s app store."
      />
      <div className={styles.storeBadgeContainer}>
        <a href={APP_STORE_URL_MAP[languageRegionCode]} target="_blank" rel="noreferrer">
          <Image alt="App Store - Trail Guides & Maps for Hiking, Camping, and Running | AllTrails" height={50} src={appleSrc} />
        </a>
        <a href={GOOGLE_PLAY_URL_MAP[languageRegionCode]} target="_blank" rel="noreferrer">
          <Image alt="Google Play - Trail Guides & Maps for Hiking, Camping, and Running | AllTrails" height={50} src={googleSrc} />
        </a>
      </div>
    </div>
  );
};

export default QRCodeDownload;
